<script>
	import thumb_5x1QFndaSjk from '$lib/Components/Youtube/images/5x1QFndaSjk.jpg?w=610';
	import thumb_8lBF9O11GS4 from '$lib/Components/Youtube/images/8lBF9O11GS4.jpg?w=610';
	import thumb_GqyuoAR9GbA from '$lib/Components/Youtube/images/GqyuoAR9GbA.jpg?w=610';
	import thumb_Hm9csxMvffU from '$lib/Components/Youtube/images/Hm9csxMvffU.jpg?w=610';
	import thumb_qJQEUSqrzeQ from '$lib/Components/Youtube/images/qJQEUSqrzeQ.jpg?w=610';
	import thumb_wPfEkiwr6O0 from '$lib/Components/Youtube/images/wPfEkiwr6O0.jpg?w=610';

	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import SocialMediaLinks from '$lib/PageSections/SocialMediaLinks/SocialMediaLinks.svelte';

	import background from './images/background.jpg';
	import customer from './images/customer.png';
	import laserMeasure from './images/laser_measure.png';
	import shipment from './images/shipment.jpg';
</script>

<Section
	backgroundImage={background}
	style="min-height: clamp(20rem, 60vh, 33vw); display: grid; place-items: center;"
	innerClass="!grid py-4"
	backgroundColor="blue"
>
	<p
		class="
    text-2xl font-bold text-indow-white!
    xs:text-lg
  "
	>
		Once you have your Indow insert(s) and installation instructions, you can
		use this page as a supplemental guide. We have videos of experts explaining
		every step of the way. If we missed something <a
			class="text-white"
			href="mailto:comfort@indowwindows.com">contact us</a
		>: 503.284.2260.
	</p>
</Section>

<Section backgroundColor="white">
	<Bubble backgroundColor="transparent">
		<nav>
			<ul class="flex list-none flex-col items-center">
				<li><a class="text-xl font-bold" href="#Measure">Measure</a></li>
				<li>
					<a class="text-xl font-bold" href="#Shipping">Shipping & Receiving</a>
				</li>
				<li>
					<a class="text-xl font-bold" href="#Installation">Installation</a>
				</li>
				<li>
					<a class="text-xl font-bold" href="#Caring-For-Your-Insert"
						>Caring for Your Insert</a
					>
				</li>
				<li><a class="text-xl font-bold" href="#Noise">Acoustic Test</a></li>
				<li>
					<a class="text-xl font-bold" href="#Customer">Share Your Story</a>
				</li>
			</ul>
		</nav>
	</Bubble>
</Section>

<Section id="Measure" backgroundColor="blue">
	<h2>Measurement</h2>
	<p>
		Looking for the Measure by Indow™ Portal or your order status? Our <a
			class="text-indow-white"
			href="/self-measure-instructions">Measure Support Page</a
		> has everything you need including a contact form to retrieve your login information.
	</p>
	<p>
		Once you are logged in, any measurements you save can be kept and turned
		into a new order. Your measurements will be waiting for you if you ever
		decide to add more Indow inserts to you home.
	</p>
	<Image src={laserMeasure} alt="Laser measurement tool." />
</Section>

<Section id="Shipping" backgroundColor="white">
	<h2>Shipping &amp; Receiving</h2>
	<p>
		You will receive all your shipping information via the email address you
		provided. This includes when your insert is shipped and tracking
		information. If you don’t receive this, contact your Fit Specialist.
	</p>
	<p>
		Upon arrival, examine the outside packaging for any damage (<a
			href="/guides/receiving-your-inserts">see here for our handling guide</a
		>). Do not refuse shipment if damage is present as the insert inside the
		packaging may be fine. Open cardboard to survey inserts for internal damage
		to the panel.
	</p>

	<Image src={shipment} alt="Unpacking an insert shipment." />

	<p>
		If you aren't present, please share these steps with the person receiving
		the shipment, and let your Fit Specialist know who that will be.
	</p>

	<p>
		If the packaging is damaged, keep all packaging until the inserts have been
		installed. If you find any damaged inserts please take pictures right away.
		Any issues must be reported to Indow within 30 days of receipt. Please
		contact your Fit Specialist immediately and <a
			href="/claim-submission-customer">submit a claim</a
		>.
	</p>
</Section>

<Section id="Installation" backgroundColor="grey-light">
	<h2>Installation</h2>
	<p>
		Watch an Indow expert go through the steps of installing, removing, &
		adjusting an Indow window insert. Watch more <a
			href="https://www.youtube.com/watch?v=TNTM7OuuYWw&list=PLe64DtqOvhg5eBSxabLVP7fUhWsWa2v0V"
			target="_blank"
			rel="noreferrer">expert installations</a
		>.
	</p>

	<Youtube posterImageSrc={thumb_qJQEUSqrzeQ} videoId="qJQEUSqrzeQ" />

	<p>
		Make sure you're installing the window insert on the same <a
			href="/resources/blog/what-is-a-frame-step">framestep</a
		> you measured on. Larger inserts may need two people for installation. Use these
		instructions:
	</p>

	<Bubble backgroundColor="white">
		<ul>
			<li>
				<p class="text-left">
					Install the bottom edge first. Make sure you adjust the corners with
					your fingers before doing anything else. (See Corner Adjustment Video
					below for more info.)
				</p>
			</li>
			<li>
				<p class="text-left">
					Move straight to the top of the insert and place both hands in the
					center of the tubing about shoulder width apart.
				</p>
			</li>
			<li>
				<p class="text-left">
					Place downward force on the insert. It may flex, this is fine. The
					downward force and possible flex will compress the bottom tubing and
					make the insert "shorter" so it can fit in the top of the frame more
					easily.
				</p>
			</li>
			<li>
				<p class="text-left">
					Move the top of the insert under the top of the frame and pull your
					fingers out to release the insert and compression tubing. Adjust the
					corners to fit and smooth out the rest of the tubing on the top.
				</p>
			</li>
			<li>
				<p class="text-left">
					Tuck in the tubing on the vertical sides of the insert and you are
					done!
				</p>
			</li>
		</ul>
	</Bubble>
</Section>

<Section>
	<h2>Measuring & Installing Your Mullions</h2>
	<p>
		It is important to measure carefully before installing the mullions into
		your window frame. Watch the video below for instructions on how to measure
		and place the mullion brackets correctly. Be sure to <a
			href="/guides/how-to-measure-for-mullions">download our mullion guide</a
		> and read through all of the instructions.
	</p>
	<Youtube posterImageSrc={thumb_Hm9csxMvffU} videoId="Hm9csxMvffU" />
</Section>

<Section id="Window-Insert-Corner-Adjustment" backgroundColor="grey-light">
	<h2>Window Insert Corner Adjustment</h2>
	<p>
		Our window inserts should fit perfectly in your window. That doesn't mean
		they don't need some help laying perfectly flat against the frame. Watch an
		expert <a
			href="https://www.youtube.com/watch?v=8lBF9O11GS4"
			target="_blank"
			rel="noreferrer">adjust the corners</a
		>
		so their insert looks perfect.
	</p>
	<p>
		See more about how <a
			href="https://www.youtube.com/watch?v=xDJHtJIX5CE&list=PLe64DtqOvhg4lrlJ_r7rBYrZ7pHPqOb2M&index=3"
			target="_blank"
			rel="noreferrer">Indow inserts work</a
		>.
	</p>

	<Youtube posterImageSrc={thumb_8lBF9O11GS4} videoId="8lBF9O11GS4" />
</Section>

<Section id="Safety-Chain-Installation" backgroundColor="blue">
	<h2>Safety Chain Installation</h2>
	<p>
		Not all inserts come with safety chains. If yours doesn't have any attached,
		don't panic, it means yours doesn't require them. <a
			href="/about-indow/care/safety-hardware">Safety hardware</a
		> provides a backup in cases of extreme weather changes that cause rapid expansion
		and contraction for large inserts. Here, an expert shows how to install and use
		safety chains.
	</p>

	<Youtube posterImageSrc={thumb_GqyuoAR9GbA} videoId="GqyuoAR9GbA" />
</Section>

<Section id="Caring-For-Your-Insert" backgroundColor="white">
	<h2>Caring For Your Insert</h2>
	<p>
		Don't be shy about removing and reinstalling your insert. They've been
		tested for hundreds of installations without wear or tear. We recommend <a
			href="https://www.youtube.com/watch?v=5x1QFndaSjk"
			target="_blank"
			rel="noreferrer">cleaning your insert</a
		>
		at least once a year with our cleaning kit or a gentle cleanser. Read our
		<a href="/about-indow/care">care guide</a> for full details.
	</p>

	<p>
		<a href="/static/pdfs/IW-Storing-Indow-Window-Inserts-10-16-19.pdf">
			Store your insert
		</a>
		wrapped in something non-abrasive, like a sheet, and flat or vertical, not leaned
		or against each other. Here's a video on
		<a
			href="https://www.youtube.com/watch?v=y-7defh60Pw"
			target="_blank"
			rel="noreferrer">how to store your Indow insert</a
		>.
	</p>

	<Youtube posterImageSrc={thumb_5x1QFndaSjk} videoId="5x1QFndaSjk" />
</Section>

<Section id="Noise" backgroundColor="grey">
	<h2>Are Your Inserts Reducing Enough Noise?</h2>
	<p>
		Not all noise issues can be solved by our window inserts. There are many
		reasons noise may not be reduced as much as you hoped. See our <a
			class="text-indow-white"
			href="/noise-disclaimer">Noise Reduction Sheet</a
		> to see how our inserts help block noise and to help check for other sources
		of noise entry. Check to make sure that your panel is correctly and fully installed.
		And then watch this video to check if you got our Acoustic Grade.
	</p>

	<Youtube posterImageSrc={thumb_wPfEkiwr6O0} videoId="wPfEkiwr6O0" />

	<p>
		Our Acoustic window inserts are thicker than our other window inserts to
		better block outside noise. In this video, our Indow expert shows how to
		measure your insert to ensure you got the right grade type.
	</p>
	<p>
		If all of these check out, please give us a call so we can help to make
		Indow work for you.
	</p>
</Section>

<Section id="Customer" backgroundColor="grey-light">
	<h2>Customer Sharing is Caring</h2>
	<p>
		Hearing directly from you (yes you) can really make a difference in
		prospective customers' decision to choose Indow. You could be what helps
		them find relief from noise and cold.
	</p>
	<p>
		If you've had a positive experience with an Indow representative or since
		you've installed your insert, please share your story on our reviews page or
		on social media. It can make a huge impact.
	</p>
	<p>
		<a
			href="https://www.reviews.io/company-reviews/store/indow1"
			target="_blank"
			rel="noreferrer">Write a Review Here</a
		>
	</p>

	<SocialMediaLinks />
</Section>

<Section id="Rewards" backgroundColor="white">
	<h2>Share the Love, Get Paid</h2>
	<p>
		Love your inserts? Love your friends? Share what made you take the plunge
		and make your home more comfortable and quiet.
	</p>
	<p class="text-2xl font-bold">YOU GET:</p>
	<p class="text-2xl font-bold text-indow-blue!">
		$50 for every order of $250 or less, OR
	</p>
	<p class="text-2xl font-bold text-indow-blue!">
		$100 for every order of $250 or more
	</p>
	<p>
		You must use the unique link that was given to you to get credit for your
		referrals. Search your email for a message with the subject line: “Share
		about Indow and earn money”.
	</p>
</Section>

<Section id="Feedback" backgroundColor="blue">
	<h2>Share Your Feedback or Get Help</h2>
	<Image src={customer} alt="A happy customer standing outside in Texas." />
	<p>
		We're always trying to get better. Your feedback can help us improve our
		measurement and installation processes.
	</p>
	<Button buttonType="anchor" href="/about-indow/contact"
		>SUBMIT FEEDBACK</Button
	>
	<p>
		If you have a current issue that needs solving, submit a case to our expert
		team.
	</p>
	<Button buttonType="anchor" href="/claim-submission-customer"
		>SUBMIT A CASE</Button
	>
</Section>
